<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 110 110"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <circle cx="55" cy="55" r="50" fill="var(--rind)" />

    <!-- manchas de corteza (piel de sapo) -->
    <ellipse cx="26" cy="26" rx="4.2" ry="3" fill="var(--rind-deep)" transform="rotate(20 26 26)" />
    <ellipse cx="46" cy="9" rx="4.2" ry="3" fill="var(--rind-deep)" transform="rotate(-15 46 9)" />
    <ellipse cx="72" cy="11" rx="4.2" ry="3" fill="var(--rind-deep)" transform="rotate(10 72 11)" />
    <ellipse cx="12" cy="58" rx="4.2" ry="3" fill="var(--rind-deep)" transform="rotate(-25 12 58)" />
    <ellipse cx="30" cy="94" rx="4.2" ry="3" fill="var(--rind-deep)" transform="rotate(30 30 94)" />
    <ellipse cx="59" cy="98" rx="4.2" ry="3" fill="var(--rind-deep)" transform="rotate(-10 59 98)" />

    <!-- cuña que falta: pulpa expuesta (radio algo menor que la corteza, para que asome un borde verde) -->
    <path d="M55 55 L95.7 31.5 A47 47 0 0 1 95.7 78.5 Z" fill="var(--melon)" />
    <ellipse cx="79" cy="43" rx="2" ry="3" fill="var(--seed)" transform="rotate(-18 79 43)" />
    <ellipse cx="83" cy="55" rx="2" ry="3" fill="var(--seed)" />
    <ellipse cx="79" cy="67" rx="2" ry="3" fill="var(--seed)" transform="rotate(18 79 67)" />
  </svg>
</template>

<script setup>
defineProps({
  size: { type: [Number, String], default: 34 },
});
</script>
